import { render, staticRenderFns } from "./AcceptCallIcon.vue?vue&type=template&id=1bfc478a&scoped=true&"
import script from "./AcceptCallIcon.vue?vue&type=script&lang=js&"
export * from "./AcceptCallIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfc478a",
  null
  
)

export default component.exports